import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { LocalStorageKeys } from 'src/app/core/enums/local-storage-keys';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { UserService } from 'src/app/features/user/service/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-menu-logado',
  templateUrl: './menu-logado.component.html',
  styleUrls: ['./menu-logado.component.scss']
})
export class MenuLogadoComponent implements OnInit{

  @Input()
  public nomeUsuario: string;

  public featureRecurso: boolean;

  public mostrarSubtopicos: boolean = false;

  constructor(private userService: UserService,
    private localStorageService: LocalStorageService,
    private oAuthService: OAuthService,
    private router: Router,
    private activeRouter: ActivatedRoute) {
     }

  ngOnInit(): void {
    this.featureRecurso = environment.featureRecurso
  }

  public redefinirSenha(): void {
    this.router.navigate(["/redefinir-senha"]);
  }

  public async signout(): Promise<void> {
    await this.DeslogarSistemas();
  }

  private async DeslogarSistemas() :Promise<void> {
    try{
      await this.userService.postSignout();
    }catch(error){}

    this.localStorageService.remove(LocalStorageKeys.userName);
    this.localStorageService.remove(LocalStorageKeys.userEmail);
    this.localStorageService.remove(LocalStorageKeys.userId);
    this.localStorageService.remove(LocalStorageKeys.userSub);

    this.oAuthService.logOut();
  }

  public obterLinkProcessamento() : void {
    window.location.href = environment.urlProcessamento
  }

  public obterLinkImpressao(): void {
    window.location.href = environment.urlImpressao
  }


  public mostrarSubtopicosMouseover(): void {
    this.mostrarSubtopicos = true;
  }
}
